import SectionHeading from '@/pages/home/components/SectionHeading';
import { updateLog } from '@/mocks/home';

export default function UpdateLog() {
  return (
    <section id="latest" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="最新地址"
              title="入口更新记录"
              desc="每次入口调整都会在这里留下时间与说明。使用任何入口前，先对照最近一条记录，能帮助你判断手上的地址是否已经过期。"
            />
            <div className="mt-7 rounded-lg bg-background-50 border border-background-200/70 p-5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-refresh-line text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">定期核对</p>
                  <p className="text-xs text-foreground-500">最近一次核对：2026-10-06</p>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                入口信息按周期核对，遇到网络环境变化会及时补充说明。若你发现实际访问情况与记录不一致，建议以时间线中更靠后的说明为准。
              </p>
            </div>
          </div>

          <ol className="lg:col-span-2 relative">
            <span className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true"></span>
            {updateLog.map((log) => (
              <li key={log.date} className="relative pl-12 pb-8 last:pb-0">
                <span className="absolute left-0 top-1 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-300 text-primary-700">
                  <i className="ri-price-tag-3-line text-base"></i>
                </span>
                <div className="rounded-lg bg-background-50 border border-background-200/70 p-5">
                  <div className="flex flex-wrap items-center gap-3">
                    <time className="font-heading text-sm font-semibold text-foreground-950">{log.date}</time>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap">
                      {log.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 text-base font-semibold text-foreground-900">{log.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{log.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}